// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3vBk7","range":"MonthRangeSwitch_range__1kjWY","disabled":"MonthRangeSwitch_disabled__30Jrs"};